import type { NotedStepDefect } from '@testflow/shared';
import { useTranslation } from 'react-i18next';
import { pickLang } from '../../lib/pick-lang.js';

// #208 Nachtrag (Entscheidung 2): „Fehler melden" fragt nach den notierten Fehlern dieser
// Durchführung. Oben die notierten Fehler als Häkchen (Vorauswahl: alle — der Aufrufer führt die
// ABGEWÄHLTEN, damit ein nachgeladener Defect automatisch mit angehakt ist), darunter das Häkchen
// für einen zusätzlichen neuen Fehler. Beides ist kombinierbar. Die Komponente hält keinen eigenen
// Zustand: was angehakt ist, entscheidet das Panel, weil es daraus Ergebnis, Sperre und Body baut.
export function NotedDefectsChoice({
  defects,
  selectedIds,
  onToggle,
  createNew,
  onCreateNewChange,
  lang,
}: {
  defects: NotedStepDefect[];
  selectedIds: string[];
  onToggle: (defectId: string) => void;
  createNew: boolean;
  onCreateNewChange: (value: boolean) => void;
  lang: string;
}) {
  const { t } = useTranslation();
  const nothingChosen = selectedIds.length === 0 && !createNew;

  return (
    <fieldset
      className="space-y-2 rounded-btn border border-[var(--border)] p-3"
      aria-describedby={nothingChosen ? 'exec-noted-pick-one' : undefined}
    >
      <legend className="px-1 text-xs font-medium text-text-body">{t('exec.noted.title')}</legend>
      <ul className="space-y-1">
        {defects.map((d) => {
          // „ETO-DEF-053 · Schritt 3 · 2LIS_03_BF · Titel" — Input nur, wenn der Schritt einen hat.
          // Ist der Katalog-Schritt gelöscht (failed_step null), bleibt der Fehler notiert und
          // wählbar; die Zeile sagt es dann (W4).
          const input = d.failed_step
            ? pickLang(lang, d.failed_step.input_de, d.failed_step.input_en)
            : '';
          const parts = [
            d.human_id,
            d.failed_step
              ? t('exec.noted.step', { no: d.failed_step.step_no })
              : t('exec.noted.stepDeleted'),
            ...(input ? [input] : []),
            d.title,
          ];
          return (
            <li key={d.defect_id}>
              <label className="flex items-start gap-2 text-xs text-text-body">
                <input
                  type="checkbox"
                  className="mt-0.5"
                  checked={selectedIds.includes(d.defect_id)}
                  onChange={() => onToggle(d.defect_id)}
                />
                <span>{parts.join(' · ')}</span>
              </label>
            </li>
          );
        })}
      </ul>
      <label className="flex items-center gap-2 border-t border-[var(--border)] pt-2 text-xs text-text-body">
        <input
          type="checkbox"
          checked={createNew}
          onChange={(e) => onCreateNewChange(e.target.checked)}
        />
        {t('exec.noted.createNew')}
      </label>
      {/* #208: Speichern ist ohne Auswahl gesperrt — der Grund steht hier, nicht nur ein grauer Knopf. */}
      {nothingChosen && (
        <p id="exec-noted-pick-one" className="text-xs text-status-fail">
          {t('exec.noted.pickOne')}
        </p>
      )}
    </fieldset>
  );
}
